import React from 'react';
import { Alert, Tag } from 'antd';

export default function ProductStatusSummary(props) {
    const { product } = props;
    const variantCount = product && product.variant_count ? product.variant_count : 0;
    const activeVariantCount = product && product.active_variant_count ? product.active_variant_count : 0;
    const hasVariants = variantCount > 0;

    return (
        <div style={{ marginBottom: 16 }}>
            {!hasVariants ? (
                <Alert type="warning" message="Sản phẩm chưa có variant, chưa sẵn sàng để bán" />
            ) : (
                <div>
                    <Tag color={product && product.status === 'active' ? 'green' : 'default'}>{product && product.status ? product.status : 'inactive'}</Tag>
                    <Tag color="blue">{variantCount} variant</Tag>
                    <Tag color={activeVariantCount > 0 ? 'green' : 'default'}>{activeVariantCount} active</Tag>
                </div>
            )}
        </div>
    );
}
